export const REGIME_SCHEDULE_COUNTS_FEATURE = "regime-schedule-counts"
export const REGIME_SCHEDULE_COUNTS_DEMAND = `feature-${REGIME_SCHEDULE_COUNTS_FEATURE}`
export const REGIME_SCHEDULE_TOTAL_EXPLANATION =
    "Counts every schedule entry in this version, including repeats in different folders. Search, skill and licence filters do not change this total."
